import type { ReactNode } from 'react'

export function Card({
    children,
    className = '',
}: {
    children: ReactNode
    className?: string
}) {
    return (
        <div
            className={`rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-sm ${className}`}
        >
            {children}
        </div>
    )
}

export function CardHeader({
    title,
    subtitle,
    actions,
}: {
    title: ReactNode
    /** Optionale Unterzeile zum Titel (z. B. Zeiträume in der Arbeitszeit-Matrix) */
    subtitle?: ReactNode
    actions?: ReactNode
}) {
    return (
        <div className='flex items-center justify-between border-b border-slate-200 dark:border-slate-700 px-5 py-3.5'>
            <div>
                <h2 className='text-sm font-semibold text-slate-700 dark:text-slate-200'>{title}</h2>
                {subtitle !== undefined && (
                    <div className='mt-0.5 text-xs text-slate-500 dark:text-slate-400'>
                        {subtitle}
                    </div>
                )}
            </div>
            {actions}
        </div>
    )
}

export function CardBody({
    children,
    className = '',
}: {
    children: ReactNode
    className?: string
}) {
    return <div className={`px-5 py-4 ${className}`}>{children}</div>
}
